module.exports = __webpack_public_path__ + "img/saved-filled.d07a0e70.svg";